import Comm from "./comm.json";
import Home from "./home.json";
import Lod from "./lod.json";
import Room from "./room.json";
import User from "./user.json";
import Alert from "./alert.json";
import Layout from "./layout.json";
import Grid from "./grid.json";

const ko = {
  ...Comm,
  ...Home,
  ...Lod,
  ...Room,
  ...User,
  ...Alert,
  ...Layout,
  ...Grid,
};

export default ko;
